import { render, staticRenderFns } from "./ArtPage3.vue?vue&type=template&id=03f71cce&scoped=true"
import script from "./ArtPage3.vue?vue&type=script&lang=js"
export * from "./ArtPage3.vue?vue&type=script&lang=js"
import style0 from "./ArtPage3.vue?vue&type=style&index=0&id=03f71cce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f71cce",
  null
  
)

export default component.exports